<template>
  <div class="col-12">
    <div class="input-group mb-3">
      <input aria-describedby="basic-addon1" aria-label=""
             class="form-control col-form-label-lg"
             name="search" placeholder="Rechercher" type="text" v-model="query"
             v-on:keyup.enter="search(false)">
      <div class="input-group-append">
        <button class="btn btn-primary" type="button" v-on:click="search(false)">{{ $t('search') }}
        </button>
      </div>
    </div>
    <small class="form-text text-muted">
      <i v-if="loading" class='fas fa-circle-notch fa-spin'></i> <span
        v-if="!loading">{{
        $t('number_of_result', {
          number: (response['total'] > 0) ? '1 - ' + response['to'] +
              '(total: ' + response['total'] + ')' : '0'
        })
      }}
    </span>
    </small>
    <div class="row mt-5">
      <div class="col-12 col-md-2">
        <h6>{{ $t('equipments') }}:</h6>
        {{ $t('all') }} <a href="#" v-on:click="check(1)">{{ $t('check') }}</a>/<a href="#" v-on:click="check(0)">{{
          $t('uncheck')
        }}</a>
        <div class="form-check custom-checkbox custom-control" v-for="(badge, index) in equipments">
          <input :disabled="loading" class="custom-control-input" type="checkbox"
                 v-bind:checked="!badge['disabled']" v-bind:id="index" v-bind:name="badge['id']"
                 v-on:click="inverseBadge(index)"/>
          <label class="custom-control-label" v-bind:for="index">
            {{ badge['name'] }}
          </label>
        </div>
      </div>
      <div class="col-12 col-md-10">
        <div class="table-responsive">
          <table class="table table-hover" id="receipt">
            <thead>
            <tr>
              <th v-for="(column, index) in columns" v-on:click="sortBy(index)">
                <span style="cursor: pointer;">{{ column['name'] }}</span>
                <span v-if="column['orderable']">
                            <i class="fas fa-arrow-down fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === 1}"></i>
                            <i class="fas fa-arrow-up fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === -1}"></i>

                        </span>
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="loading && page === 1">
              <td colspan="7"><i class="fas fa-circle-notch fa-spin"></i> {{ $t('data_loading') }}
              </td>
            </tr>
            <tr v-if="data.length === 0 && loading === false">
              <td colspan="7">{{ $t('no_results_found') }}</td>
            </tr>
            <tr v-for="entry in filteredResults" v-if="!loading || page > 1">
              <th scope="row">{{ entry['id'] }}</th>
              <td>{{ entry['name'] }}</td>
              <td>{{ entry['location'] }}</td>
              <td>
                {{ $t('main') }}:<br/>
                <ul v-for="main in entry['main']">
                  <li>
                    {{ main['name_formatted'] }}
                    <a v-bind:href="'tel:' + main['phone_callable']"><i
                        class="fas fa-phone fa-flip-horizontal"></i></a>
                    <a v-bind:href="'mailto:' + main['email']"><i class="fas fa-envelope"></i></a>
                  </li>
                </ul>
                <template v-if="entry['technicals'].length > 0">
                  {{ $t('technicals') }}:<br/>
                  <ul v-for="main in entry['technicals']">
                    <li>
                      {{ main['name_formatted'] }}
                      <a v-bind:href="'tel:' + main['phone_callable']"><i
                          class="fas fa-phone fa-flip-horizontal"></i></a>
                      <a v-bind:href="'mailto:' + main['email']"><i
                          class="fas fa-envelope"></i></a>
                    </li>
                  </ul>
                </template>
                <template v-if="Object.keys(entry['financials']).length > 0">
                  {{ $t('financials') }}:<br/>
                  <ul v-for="main in entry['financials']">
                    <li>
                      {{ main['name_formatted'] }}
                      <a v-bind:href="'tel:' + main['phone_callable']"><i
                          class="fas fa-phone fa-flip-horizontal"></i></a>
                      <a v-bind:href="'mailto:' + main['email']"><i
                          class="fas fa-envelope"></i></a>
                    </li>
                  </ul>
                </template>
              </td>
              <td><a v-bind:href="'companies/' + entry['id']">{{ $t('details') }}</a></td>
            </tr>
            <tr v-if="!loading && data.length !== 0 && response['last_page'] > page">
              <td id="loadMore" colspan="6" v-on:click="loadMore">{{ $t('load_more') }}</td>
            </tr>
            <tr v-if="loading && data.length !== 0 && response['last_page'] > page">
              <td colspan="6"><i class="fas fa-circle-notch fa-spin"></i>{{
                  $t('next_results_loading')
                }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['equipments_id'],
  data: function () {
    return {
      sortCell: '',
      loading: true,
      page: 1,
      query: '',
      data: [],
      companies: [],
      response: [],
      equipments: [],
      columns: {
        'id': {
          name: this.$i18n.t('id'),
          db_name: 'id',
          orderable: true,
          sortDirection: 1,
          type: 'number'
        },
        'name': {
          name: this.$i18n.t('name'),
          db_name: 'name',
          orderable: true,
          sortDirection: 1,
          type: 'text'
        },
        'title': {
          name: this.$i18n.t('address'),
          db_name: 'city',
          orderable: false,
          sortDirection: 1,
          type: 'text'
        },
        'contact': {
          name: this.$i18n.t('contact'),
          db_name: '',
          orderable: false,
          sortDirection: 1,
          type: ''
        },
        'details': {
          name: this.$i18n.t('details'),
          db_name: '',
          orderable: false,
          sortDirection: 1,
          type: ''
        },
      },
    }
  },
  filters: {
    displayDate: function (value) {
      var parts = value.split(' ')[0].split('-');
      var date = new Date(parts[0], parts[1], parts[2]);
      return ('0' + date.getDate()).slice(-2) + '/' + ('0' + date.getMonth()).slice(-2) + '/' + date.getFullYear();
    },
  },
  created: function () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    filteredResults: function () {
      var data = this.data;
      if (this.sortCell) {
        var cell = this.columns[this.sortCell];
        var direction = cell['sortDirection'];
        if (cell['type'] === 'date') {
          data = data.slice().sort(function (a, b) {
            var a1 = new Date(a[cell['db_name']]);
            var b1 = new Date(b[cell['db_name']]);

            return (a1.getTime() === b1.getTime()) ? 0 : ((a1.getTime() > b1.getTime()) ? 1 : -1) * cell['sortDirection'];
          });
        } else if (cell['type'] === 'number') {
          data = data.slice().sort(function (a, b) {
            var a1 = a[cell['db_name']];
            var b1 = b[cell['db_name']];

            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
          });
        } else if (cell['type'] === 'text') {
          data = data.slice().sort(function (a, b) {
            var a1 = a[cell['db_name']];
            var b1 = b[cell['db_name']];

            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
          });
        }
      }
      return data;
    },
  },
  mounted: function () {
    axios.post('equipments/available', {})
        .then(response => {
          this.equipments = response.data;
          this.equipments.forEach(function (item) {
            if (this.equipments_id.length > 0) {
              if (this.equipments_id.indexOf(item['id']) < 0) {
                item['disabled'] = true;
              } else {
                item['disabled'] = false;
              }
            } else {
              item['disabled'] = false;
            }

          }.bind(this));
          this.search();
        });
  },
  methods: {
    throttle: function (func, wait, options) {
      var context, args, result;
      var timeout = null;
      var previous = 0;
      if (!options) options = {};
      var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      };
      return function () {
        var now = Date.now();
        if (!previous && options.leading === false) previous = now;
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
          if (timeout) {
            clearTimeout(timeout);
            timeout = null;
          }
          previous = now;
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        } else if (!timeout && options.trailing !== false) {
          timeout = setTimeout(later, remaining);
        }
        return result;
      };
    },
    handleScroll: function () {
      if (!this.loading) {
        if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
          this.loadMore();
        }
      }
    },
    isInViewport: function (elem) {
      var bounding = elem.getBoundingClientRect();
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    loadMore: function () {
      this.page++;
      this.search(true);
    },
    sortBy: function (index) {
      if (this.columns[index]['orderable'] === true) {
        this.sortCell = index;
        this.columns[index]['sortDirection'] *= -1;
      }
    },
    check: function (value) {
      this.loading = true;
      this.equipments.forEach((equipment, index) => {
        equipment['disabled'] = value === 0;
      });
      this.$forceUpdate();
      this.search();
    },
    inverseBadge: function (index) {
      this.equipments[index]['disabled'] = !this.equipments[index]['disabled'];
      this.$forceUpdate();
      this.search();
    },
    search: function (next_page = false) {
      this.loading = true;
      var equipments_id = [];
      this.equipments.forEach(function (item) {
        if (!item['disabled']) {
          equipments_id.push(item['id']);
        }
      });
      if (!next_page) {
        this.page = 1;
        this.data = [];
      }
      axios
          .post('companies/search', {
            query: this.query,
            equipments: equipments_id,
            page: this.page
          })
          .then(response => {
            if (next_page) {
              this.data = this.data.concat(response.data.data);
            } else {
              this.data = response.data.data;
            }
            this.response = response.data;
            this.loading = false;
          });

    },
  }
}
</script>
